"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
exports.EmailCanvasBlockEditImportedContentButton = ({ hasImportedContent, contentCanBeChanged, editImportedContent, }) => {
    if (!hasImportedContent) {
        return null;
    }
    const disabled = !hasImportedContent || !contentCanBeChanged;
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
        react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { tooltip: "Edit imported content", osysIcon: "edit", disabled: disabled, osysName: "EmailCanvasBlockEditImportedContentButton", onClick: () => {
                if (disabled) {
                    return;
                }
                editImportedContent();
            } })));
};
//# sourceMappingURL=EditImportedContentButton.js.map